import {
  CustomPropertyState,
  CustomPropertyAction,
  CustomPropertyActionTypes as ActionTypes,
} from './types';

const initialCustomPropertyState: CustomPropertyState = {
  refresh: {},
  /** Load中か */
  isLoading: false,
  /** 送信処理中か */
  isSubmitting: false,
  /** カスタムプロパティの項目定義リスト */
  customPropertyLayoutList: [],
  /** カスタムプロパティの設定情報 */
  customPropertyLayoutSettingList: [],
};

const customPropertyReducer = (
  state: CustomPropertyState = initialCustomPropertyState,
  action: CustomPropertyAction,
): CustomPropertyState => {
  switch (action.type) {
    case ActionTypes.INIT:
      return initialCustomPropertyState;

    case ActionTypes.REFRESH:
      return { ...state, refresh: {} };

    case ActionTypes.LOADING:
      return { ...state, isLoading: action.payload };

    case ActionTypes.SUBMITTING:
      return { ...state, isSubmitting: action.payload };

    case ActionTypes.SET_CUSTOM_PROPERTY_LAYOUT_LIST:
      return { ...state, customPropertyLayoutList: action.payload };

    case ActionTypes.SET_CUSTOM_PROPERTY_LAYOUT_SETTING_LIST:
      return { ...state, customPropertyLayoutSettingList: action.payload };

    default:
      return state;
  }
};

export default customPropertyReducer;
